/**
 * Defense-in-depth URL validator. pga-service validates these
 * upstream; this is the second line — never set element src/href without
 * passing through isSafeUrl first. Refuses javascript:, data:, blob:,
 * file:, and anything else exotic.
 */

export function isSafeUrl(s: unknown): s is string {
  if (typeof s !== 'string' || s.length === 0) return false;
  try {
    const u = new URL(s);
    return u.protocol === 'http:' || u.protocol === 'https:';
  } catch {
    return false;
  }
}
